import React from 'react';
import i18next from 'i18next';
import { bool, string, func } from 'prop-types';

import BusinessHours from '~components/BusinessHours';
import { DISPATCH_METHODS } from '~constants/address';

import styles from './styles.module.scss';

function Message({
  onlyDeliveryAvailable,
  onlyPickupAvailable,
  closedByAttribute,
  currentDispatchMethod,
  continueWith,
  businessHours
}) {
  return (
    <div>
      {onlyDeliveryAvailable && (
        <div className="row">
          <div className="column m-bottom-2 center full-width">
            <p className="m-bottom-2">
              {i18next.t('StoreInfo:availableTitle')}
              <strong className="bold"> {i18next.t('StoreInfo:availableDelivery')}</strong>
            </p>
          </div>
        </div>
      )}
      {onlyPickupAvailable && (
        <div className="row">
          <div className="column m-bottom-2 center full-width">
            <p className="m-bottom-2">
              {i18next.t('StoreInfo:availableTitle')}
              <strong className="bold"> {i18next.t('StoreInfo:availablePickup')}</strong>
            </p>
          </div>
        </div>
      )}
      {!closedByAttribute && (
        <div className="column center full-width">
          <p>
            {currentDispatchMethod === DISPATCH_METHODS.PICKUP
              ? i18next.t('StoreInfo:subtitleStoreClosedLocal')
              : i18next.t('StoreInfo:subtitleStoreClosedDelivery')}
          </p>
          <div className={styles.body}>
            <BusinessHours
              closedBySwitch={closedByAttribute}
              businessHours={businessHours}
              containerClassName="center"
              dispatchType={currentDispatchMethod}
              className={`row ${styles.businessHoursContainer}`}
              noTitle
            />
          </div>
        </div>
      )}
      {(onlyPickupAvailable || onlyDeliveryAvailable) && (
        <div className="row center">
          <button type="button" onClick={continueWith} className="button secondary font-size-16">
            {i18next.t(`StoreInfo:${onlyDeliveryAvailable ? 'continueDelivery' : 'continuePickup'}`)}
          </button>
        </div>
      )}
    </div>
  );
}

Message.propTypes = {
  businessHours: string,
  closedByAttribute: bool,
  continueWith: func,
  currentDispatchMethod: string,
  onlyDeliveryAvailable: bool,
  onlyPickupAvailable: bool
};

export default Message;
